// extracted by css-extract-rspack-plugin
export default {"actionListTitle":"IssueTemplateItem-module__actionListTitle__eNRhM","templateItemContainer":"IssueTemplateItem-module__templateItemContainer__LpFyz"};